<section class="information-wrapper">
  <section class="section-wrapper">
    <section class="section-content">
      <ul>
        <li *ngFor="let drug of data; let i = index">
          <div style="display: flex;">
            <div>
              <gen-button [type]="'emphasis'"
                          [iconClass]="'fa fa-times blue-color'"
                          [text]="''"
                          (click)="removeDrug(i)">
              </gen-button>
            </div>
            <div><a href="javascript:void(0)" (click)="navigate(drug.id)">{{ drug.CommonName }}</a></div>
          </div>
        </li>
      </ul>
    </section>
  </section>
</section>
